module.exports = __webpack_public_path__ + "img/no_data.bfc92c69.png";